export default __webpack_public_path__ + "static/2-brightness-b272d61bd224ffd5975c66b83ea4d54a.png";